import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAvailableCities } from "../../../store/adminDataStore";
import { CITY_CONFIG } from "../../../config/cities";

export default function CitySelectionSection() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const lang = (i18n.language?.split("-")[0] ?? "en") as "zh" | "en" | "ja";
  // Derive available cities from active services.city_scope — no MOCK_CITIES
  const availableCities = useAvailableCities();

  return (
    <section className="bg-[#F7F6F3] py-24 lg:py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-[0.4em] text-[#C8B8A6] mb-4">Japan</p>
          <h2 className="text-4xl lg:text-5xl font-extralight text-[#2C2C2C] mb-4" style={{ letterSpacing: "-0.02em" }}>
            {t("tabifoto.cities.section_title")}
          </h2>
          <p className="text-sm text-[#2C2C2C]/40 font-light tracking-wide">
            {t("tabifoto.cities.section_sub")}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 lg:gap-6">
          {CITY_CONFIG.map((city, index) => {
            const isAvailable = availableCities.has(city.id);
            return (
              <div
                key={city.id}
                onClick={() => isAvailable && navigate(`/booking?city=${city.id}`)}
                className={`relative overflow-hidden rounded-lg group ${
                  index === 0 ? "md:col-span-1" : ""
                } ${isAvailable ? "cursor-pointer" : "cursor-default"}`}
                style={{ aspectRatio: "1/1" }}
              >
                <img
                  src={city.image}
                  alt={city.name[lang]}
                  className={`w-full h-full object-cover object-top transition-transform duration-700 ${
                    isAvailable ? "group-hover:scale-105" : "grayscale opacity-60"
                  }`}
                  loading="lazy"
                />
                <div className={`absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent transition-opacity duration-300 ${
                  isAvailable ? "group-hover:from-black/80" : ""
                }`} />

                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-2xl lg:text-3xl font-light text-white tracking-wide">
                    {city.name[lang]}
                  </h3>
                  {!isAvailable && (
                    <span className="mt-2 inline-block text-xs uppercase tracking-widest text-white/50 border border-white/20 px-3 py-1 rounded-full">
                      {t("tabifoto.cities.coming_soon")}
                    </span>
                  )}
                  {isAvailable && (
                    <div className="mt-2 flex items-center gap-2 text-xs text-white/60 uppercase tracking-widest opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
                      <span>Explore</span>
                      <div className="w-3 h-3 flex items-center justify-center">
                        <i className="ri-arrow-right-line" />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
